import React, { useState } from "react";
import axios from "../../../axios/index";
import { Link } from "react-router-dom";

// styles
import styles from "./signUp.module.css";
import "react-toastify/dist/ReactToastify.css";

// components
import VerifySignUpCode from "./VerifySignUpCode";
import { ToastContainer, toast } from "react-toastify";

// img
import homeIcon from "../../../assets/img/HomePage/AzarMelk.svg";
import sideImg from "../../../assets/register.png";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

const SignUp = () => {
  let state = useLocation();
  const [signUpData, setSignUpData] = useState({
    phone: "",
    name: "",
    lastName: "",
    responseText: "",
  });

  const [btnLoader, setBtnLoader] = useState(false);

  const changeHandler = e => {
    if (e.target.type === "number") {
      if (e.target.value === "" || e.target.value.match(/^[0-9]+$/)) {
        if (e.target.value.length <= 11) {
          setSignUpData(prev => {
            return { ...prev, [e.target.name]: e.target.value };
          });
        }
      }
    } else if (e.target.type === "text") {
      // if (e.target.value === "" || e.target.value.match(/^[a-zA-Z]+$/)) {
      setSignUpData(prev => {
        return { ...prev, [e.target.name]: e.target.value };
      });
      // }
    }
  };

  // Remove Symbol From Input Number
  const removeSymbolNumberHandler = e => {
    const removeSymbolNumber = ["e", "E", ".", "-"];

    if (removeSymbolNumber.includes(e.key)) {
      e.preventDefault();
    }
  };

  const [formNumber, setFormNumber] = useState(1);
  const showForm = () => {
    switch (formNumber) {
      case 1:
        return (
          <>
            <ToastContainer
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover={false}
              theme="light"
            />
            <div className="d-flex justify-content-center align-items-md-start align-items-center py-md-0 py-5 flex-column" dir="rtl">
              <div className="w-100 d-flex flex-md-row flex-column align-items-center justify-content-md-end justify-content-center">
                <Link to="/" className={`mt-4 mb-5 ${styles.logo_container}`} style={{ zIndex: "5" }}>
                  <img src={homeIcon} alt="icon" />
                </Link>
                <form
                  onSubmit={e => e.preventDefault()}
                  className={`d-flex align-items-center justify-content-start pt-4 px-md-5 px-0 flex-column ${styles.form_container}`}>
                  <h1 className={`mb-5 ${styles.form_title}`}>ثبت نام</h1>
                  <div className="w-100 d-flex flex-column align-items-start justify-content-center position-relative mb-4 px-3">
                    {/* <h1 className={`mb-5 ${styles.form_title2}`}>شماره موبایل</h1> */}
                    <div className="w-100 d-flex flex-column align-items-start justify-content-center mb-4">
                      <h6 className={styles.input_title}>نام خود را وارد کنید</h6>
                      <input className={styles.form_input} type="text" name="name" value={signUpData.name} onChange={changeHandler} />
                    </div>
                    <div className="w-100 d-flex flex-column align-items-start justify-content-center mb-4">
                      <h6 className={styles.input_title}>نام خانوادگی خود را وارد کنید</h6>
                      <input className={styles.form_input} type="text" name="lastName" value={signUpData.lastName} onChange={changeHandler} />
                    </div>
                    <div className="w-100 d-flex flex-column align-items-start justify-content-center mb-4">
                      <h6 className={styles.input_title}>شماره موبایل خود را وارد کنید</h6>
                      <input
                        className={styles.form_input}
                        type="number"
                        name="phone"
                        value={signUpData.phone}
                        onChange={changeHandler}
                        onKeyDown={removeSymbolNumberHandler}
                      />
                    </div>
                    <div className={styles.input_bottom_container}>
                      قبلا ثبت نام کرده‌اید؟{" "}
                      <Link to="/ورود" className={styles.login_btn}>
                        ورود
                      </Link>
                    </div>
                  </div>
                  {btnLoader ? (
                    <div className={styles.btn_loader_container}>
                      <div className={styles.btn_spinner}></div>
                    </div>
                  ) : (
                    <div className="w-100 d-flex align-items-center justify-content-center mb-3" onClick={postHandler}>
                      <button type="submit" className={styles.form_submit_btn}>
                        ثبت نام
                      </button>
                    </div>
                  )}
                </form>
                <div className={styles.side_img}>
                  <img src={sideImg} alt="img" />
                </div>
              </div>
            </div>
          </>
        );
      case 2:
        return (
          <VerifySignUpCode
            phone={signUpData.phone}
            name={signUpData.name}
            lastName={signUpData.lastName}
            estateId={state?.state?.estateId || null}
            subject={state?.state?.subject || null}
            resiverId={state?.state?.resiverId || null}
          />
        );

      default:
        break;
    }
  };

  return <React.Fragment>{showForm(1)}</React.Fragment>;

  async function postHandler() {
    try {
      notify("درحال ارسال کد تایید", "success");
      setBtnLoader(true);
      var data = {
        name: signUpData.name,
        family: signUpData.lastName,
        phoneNumber: signUpData.phone?.toString(),
      };

      if (data.phoneNumber.match(/^(09)[0-9]+$/) && data.phoneNumber.length === 11) {
        const apiData = await axios.post("Auth/register", data);
        setSignUpData(prev => {
          return { ...prev, responseText: apiData.data.metaData.message };
        });
        // console.log(apiData)
      } else {
        notify("خطایی رخ داد", "error");
        // throw new Error("شماره موبایل اشتباه است");
      }
    } catch (error) {
      notify("شماره موبایل اشتباه است", "error");
      // console.log(error)
    } finally {
      setBtnLoader(false);
      setFormNumber(2);
    }

    setBtnLoader(false);
    // console.log(apiData);
  }

  function notify(text, type) {
    if (type === "success") {
      toast.success(text, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      // postHandler()
    } else {
      toast.error(text, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setBtnLoader(false);
    }
  }
};

export default SignUp;
